var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.question.QuestionText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }